import { useState, useEffect } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import clsx from 'clsx';
import MediaQuery from 'react-responsive';
import { useGetAccountsStore } from '@lib/store';
import { HelpersUtils, RoutePaths, SessionStorageUtils } from '@shared/utils';
import { Logo, Logout, MessageIndicator } from '@shared/widgets';

interface MenuType {
  link: string;
  name: string;
}

interface HeaderMobileType {
  menu: MenuType[];
}

export const HeaderMobile = (props: HeaderMobileType) => {
  const params = useParams<{ id: string }>();
  const location = useLocation();

  const accountsStore = useGetAccountsStore();

  const [isOpen, setIsOpen] = useState(false);

  const icaState = SessionStorageUtils.getIcaState();

  useEffect(() => {
    if (isOpen) {
      HelpersUtils.appScroll.disable();
    } else {
      HelpersUtils.appScroll.enable();
    }
  }, [isOpen]);

  return (
    <div className='fixed top-0 left-0 z-1000 h-16 w-full bg-[linear-gradient(180deg,_#282828,_#212121)] shadow-[12px_12px_24px_0_#0000003b,_inset_0_2px_0_0_#343434]'>
      {isOpen && (
        <>
          <div className='fixed inset-0 z-1000 bg-black/40' />
          <div className='fixed top-0 left-0 z-1010 h-[80vh] w-[54vw] bg-gradient-to-b from-[#282828] to-[#212121] px-16 pt-27 pb-16 shadow-[12px_12px_24px_0_#0000003b,_inset_0_2px_0_0_#343434] [@media(max-width:512px)]:h-full [@media(max-width:512px)]:w-full'>
            <div className='flex h-full flex-col justify-between'>
              <div className='mb-15 flex flex-col'>
                {accountsStore.data[0] &&
                  props.menu.map((item) => {
                    let linkTo = item.link;
                    if (item.link.includes(':id')) {
                      linkTo = item.link.replace(':id', params.id || accountsStore.data[0].Id);
                    }
                    const isActive = location.pathname === linkTo;

                    return (
                      <NavLink
                        to={linkTo}
                        key={item.link}
                        onClick={() => setIsOpen((prev) => !prev)}
                        className='flex h-15 items-center justify-between border-b-[1px] border-b-[#888] no-underline'
                      >
                        <div className='mobile-list__item-text relative'>
                          <span className={clsx('text-white uppercase', isActive && '!text-[#888]')}>{item.name}</span>
                          {isActive && <div className='absolute top-1 -left-5 h-2 w-2 rounded-full bg-[#a73f33]'></div>}
                        </div>
                      </NavLink>
                    );
                  })}
              </div>
              <div>
                <div className='mb-4 text-[#f2f2f2] uppercase'>
                  <div className='text-base font-semibold'>{icaState.user.name}</div>
                  <div className='mt-1 flex items-center justify-start text-xs font-semibold text-[#888]'>
                    <div className='mr-1'>Last login:</div>
                    <div>{dayjs(icaState.user.lastLogin).format('ddd, DD.MM.YY [AT] hh:mm A')}</div>
                  </div>
                </div>
                <Logout className='flex h-12 cursor-pointer items-center justify-between border-b border-white/40' mobile />
              </div>
            </div>
          </div>
        </>
      )}
      <MediaQuery query='(min-width: 416px) and (max-width: 768px)' className='none fixed top-0 left-0 z-1000 h-full w-full bg-[#191919cc]' />
      <div className='flex items-center justify-between'>
        <div
          className='relative z-[1010] flex h-16 w-16 cursor-pointer flex-col items-center justify-center bg-[#a73f33] transition-all duration-300'
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <div
            className={clsx(
              'absolute top-1/2 left-1/2 h-0.5 w-[22px] -translate-x-1/2 -translate-y-1/2 bg-white transition-all duration-300',
              isOpen ? 'mt-0 rotate-45' : '-mt-1',
            )}
          />
          <div
            className={clsx(
              'absolute top-1/2 left-1/2 h-0.5 w-[22px] -translate-x-1/2 -translate-y-1/2 bg-white transition-all duration-300',
              isOpen ? 'mt-0 -rotate-45' : 'mt-1.5',
            )}
          />
        </div>
        <div className='relative h-4 w-31'>
          <Logo width='100%' height='100%' />
        </div>
        <div className='relative -left-3 flex h-16 w-16 items-center justify-center'>
          <NavLink to={RoutePaths.messages.onNavigate({ dir: 'inbox' })} className='relative -mr-4 block'>
            <MessageIndicator />
          </NavLink>
        </div>
      </div>
    </div>
  );
};
